<template>
    <div class="meeting-ongoing-container">
        <div class="mt-header" :style="mtHeaderStyle">
            <div class="mt-title">{{ meeting_title }}</div>
        </div>
        <div class="mt-record">
            <div class="mt-record-content" ref="recordContent">
                <div v-for="(item, index) in res_data" :key="index" class="record-item">
                    <div class="mt-record-header">
                        <span class="speaker">{{ item.speaker }}</span>
                        <span v-if="item.isspeaking" class="time">讲话中</span>
                        <span class="time">{{ item.time }}</span>
                        <img v-if="item.isspeaking" class="icon-micro" :src="iconmicro" />
                    </div>
                    <div class="content">
                        {{ item.content }}
                    </div>
                </div>
            </div>

            <div class="mt-record-state">
                <img class="recording" v-if="!onPose && started" :src="recording" />
                <img class="recording" v-if="onPose && started" :src="stoppng" />
                <div class="state">
                    <div v-if="!started">实时会议-未开始</div>
                    <div v-if="!onPose && started">会议记录中...</div>
                    <div v-if="onPose && started">实时会议-暂停中</div>
                    <div class="record-time">{{ record_time }}</div>
                </div>
                <div class="action">
                    <img v-if="!started || onPose" :src="iconplay" @click="controlmettings" />
                    <img v-if="started && !onPose" :src="iconpause" @click="controlmettings" />
                    <img v-if="started" :src="iconstop" @click="recClose" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
/* eslint-disable */
// import { message } from 'ant-design-vue';
import { reactive, ref, onActivated, createVNode, nextTick, computed, onMounted, onBeforeUnmount, onDeactivated, watch } from 'vue';
import { useRouter } from 'vue-router'
// import { message } from 'ant-design-vue';
import axios from 'axios';

import iconmicro from '@/assets/images/icon_micro.png';
import recording from '@/assets/images/recording.gif';
import stoppng from '@/assets/images/stop.png';
import iconplay from '@/assets/images/icon_play.png';
import iconpause from '@/assets/images/icon_pause.png';
import iconstop from '@/assets/images/icon_stop.png';
import { BASE_URL, WS_BASE_URL } from '@/config/api';
const router = useRouter()

const res_data = ref([]);
const recordContent = ref(null);
let record_time = ref('00:00');
let record_time_interval = null;
let meeting_id = router.currentRoute.value.params.id

// 存储上一次的meeting_id用于比较
let previousMeetingId = ref(meeting_id);

let mtHeaderStyle = {
    backgroundImage: `url(${require('@/assets/images/mt_bg.png')})`,
}

const set_record_time = () => {
    let time = record_time.value ? parseInt(record_time.value.split(':')[0]) * 60 + parseInt(record_time.value.split(':')[1]) : 0;
    record_time_interval = setInterval(() => {
        time += 1
        const minutes = Math.floor(time / 60).toString().padStart(2, '0');
        const seconds = (time % 60).toString().padStart(2, '0');
        record_time.value = `${minutes}:${seconds}`;
    }, 1000)
}



// 暂停计时增长
const stop_record_time = () => {
    clearInterval(record_time_interval)
}

// 控制会议状态
const controlmettings = () => {
    console.log('controlmettings')
    if (!started.value) {
        // 如果会议未开始，先关闭可能存在的WebSocket连接
        closeWebSocket();
        recOpen()
        started.value = true
        // 初始化WebSocket连接 - 只有在会议开始后才初始化
        initWebSocket()
        // 当前时间精确到秒
        set_record_time()
    } else {
        if (onPose.value) {
            // 继续会议，保持WebSocket连接
            cont()
        } else {
            // 暂停会议，保持WebSocket连接但停止发送数据
            pose()
            // 暂停计时增长
            stop_record_time()
        }
    }
    // 如果当前是
}

// 插入数据之后滚动到可视范围
const scrollToBottom = () => {
    nextTick(() => {
        if (recordContent.value) {
            const scrollHeight = recordContent.value.scrollHeight;
            const height = recordContent.value.clientHeight;
            const maxScrollTop = scrollHeight - height;
            recordContent.value.scrollTo({
                top: maxScrollTop,
                behavior: 'smooth'
            });
        }
    });
};
// setInterval(() => {
//     res_data.value.push({
//         time: '2024-05-01 12:00:00',
//         speaker: '王健林',
//         content: '劳斯莱斯历史了' + res_data.value.length
//     })
//     scrollToBottom()
// }, 2000)
const res_tmp_data = ref({});

let audio_src = `${BASE_URL}/audio/1.mp3`;

const formRef = ref();
let meeting_title = ref('');
let onPose = ref(false);
let started = ref(false);
let lastFetchId = 0;

const formState = reactive({
    name: '',
    users: [],
    meettime: '',
});
const state = reactive({
    data: [],
    value: [],
    fetching: false,
});
const meettime = reactive({
    data: [
        { label: '立刻开始', value: '立刻开始' },
    ],
    value: [],
    fetching: false,
});


const formItemLayout = {
    labelCol: {
        span: 5,
    },
    wrapperCol: {
        span: 16,
    }
}
const formTailLayout = {
    labelCol: {
        span: 4,
    },
    wrapperCol: {
        span: 16,
        offset: 4,
    }
}
const myPermission = computed(() => {
    const permission = localStorage.getItem('myPermission') || '{}'
    return JSON.parse(permission)
})
const handleChange = () => {
    lastFetchId += 1;
    const fetchId = lastFetchId;
    state.data = [];
    state.fetching = true;
    fetch(`${BASE_URL}/user?active_id=${myPermission.value.id}`)
        .then(response => response.json())
        .then(body => {
            if (fetchId !== lastFetchId) {
                // for fetch callback order
                return;
            }
            console.log('body', body)
            const data = body.items.map(user => ({
                label: user.name,
                value: user.id,
            }));
            state.data = data;
            state.fetching = false;
        }).catch(() => { });
}
handleChange();

// 监听meeting_id变化
watch(() => router.currentRoute.value.params.id, (newId, oldId) => {
    console.log('路由参数id变化：', oldId, '->', newId);
    if (newId !== oldId) {
        meeting_id = newId;
        // 如果WebSocket已存在，先关闭后重新连接
        closeWebSocket();
        initWebSocket();
    }
});

onActivated(() => {
    console.log('组件激活，检查meeting_id');
    // 清空会议记录数据
    res_data.value = [];
    
    setinit();
    
    // 仅在会议已开始时才处理WebSocket连接
    if (started.value) {
        const currentMeetingId = router.currentRoute.value.params.id;
        if (currentMeetingId !== previousMeetingId.value) {
            console.log('meeting_id已变化，重新初始化WebSocket');
            meeting_id = currentMeetingId;
            closeWebSocket();
            initWebSocket();
        } else if (!ws || ws.readyState !== WebSocket.OPEN) {
            // 如果没有活动的WebSocket连接，重新初始化
            console.log('没有活动的WebSocket连接，重新初始化');
            initWebSocket();
        }
    } else {
        console.log('会议尚未开始，不建立WebSocket连接');
    }
})


const setinit = () => {
    // 设置页面进入loading
    state.fetching = true;
    meeting_id = router.currentRoute.value.params.id
    fetch(`${BASE_URL}/meeting/${meeting_id}?active_id=${myPermission.value.id}`)
        .then(response => response.json())
        .then(data => {
            // data.speaker = 1,2 变成数组
            let userlist = data.speaker.includes(',') ? data.speaker.split(',') : [data.speaker];
            // 遍历 userlist 并结合 state.data的数据 获得 label和value数组
            const selectedUsers = userlist.map(userName => {
                const user = state.data.find(item => item.label === userName);
                return {
                    label: user.label,
                    value: user.value
                };
            });
            formState.users = selectedUsers;
            // 
            console.log('formState.users', [data.speaker])
            formState.name = data.title
            meeting_title.value = data.title
            formState.meettime = '立刻开始'
        }).catch(() => { });
}
setinit()
// 暂停
const pose = () => {
    onPose.value = true;
    console.log('会议已暂停，WebSocket保持连接但暂停发送数据');
    // 仅停止录音，不关闭WebSocket
    recStop();
    // 暂停计时增长
    stop_record_time();
}



// 继续
const cont = () => {
    onPose.value = false;
    recOpen();
    started.value = true;
    // 继续计时
    set_record_time();
}

import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
const save = () => {
    console.log('save')
    // 确认框提示
    Modal.confirm({
        title: '确认结束？',
        icon: createVNode(ExclamationCircleOutlined),
        okText: '确认',
        cancelText: '取消',
        onOk() {
            // 结束会议
        },
    });
}

import Recorder from 'recorder-core';

//引入mp3格式支持文件；如果需要多个格式支持，把这些格式的编码引擎js文件放到后面统统引入进来即可
import 'recorder-core/src/engine/mp3';
import 'recorder-core/src/engine/mp3-engine';
//录制wav格式的用这一句就行
import 'recorder-core/src/engine/wav';

//可选的插件支持项，这个是波形可视化插件
import 'recorder-core/src/extensions/waveview';
import { initCustomFormatter } from 'vue';

let testOutputWavLog = false;//顺带打一份wav的log，录音后执行mp3、wav合并的demo代码可对比音质
let testSampleRate = 192000;
let testBitRate = 64;

let SendInterval = 1350;//mp3 chunk数据会缓冲，当pcm的累积时长达到这个时长，就会传输发送。这个值在takeoffEncodeChunk实现下，使用0也不会有性能上的影响。

// RealTimeSendTryReset();

let realTimeSendTryTime = 0;
let realTimeSendTryNumber = 0;
let transferUploadNumberMax;
let realTimeSendTryBytesChunks = [];
let realTimeSendTryClearPrevBufferIdx;
let realTimeSendTryWavTestBuffers;
let realTimeSendTryWavTestSampleRate;

let speaker_number = 1;

//重置环境
const RealTimeSendTryReset = () => {
    realTimeSendTryTime = 0;
}

//=====实时处理核心函数==========
const RealTimeSendTry = (chunkBytes, isClose) => {
    if (chunkBytes) {//推入缓冲再说
        realTimeSendTryBytesChunks.push(chunkBytes);
    };

    var t1 = Date.now();
    if (!isClose && t1 - realTimeSendTryTime < SendInterval) {
        return;//控制缓冲达到指定间隔才进行传输
    };
    realTimeSendTryTime = t1;
    var number = ++realTimeSendTryNumber;

    //mp3缓冲的chunk拼接成一个更长点的mp3
    var len = 0;
    for (var i = 0; i < realTimeSendTryBytesChunks.length; i++) {
        len += realTimeSendTryBytesChunks[i].length;
    };
    var chunkData = new Uint8Array(len);
    for (var i = 0, idx = 0; i < realTimeSendTryBytesChunks.length; i++) {
        var chunk = realTimeSendTryBytesChunks[i];
        chunkData.set(chunk, idx);
        idx += chunk.length;
    };
    realTimeSendTryBytesChunks = [];

    //推入传输
    var blob = null, meta = {};
    if (chunkData.length > 0) {//mp3不是空的
        blob = new Blob([chunkData], { type: "audio/mp3" });
        meta = Recorder.mp3ReadMeta([chunkData.buffer], chunkData.length) || {};//读取出这个mp3片段信息
    };
    TransferUpload(number
        , blob
        , meta.duration || 0
        , {
            set: {
                type: "mp3"
                , sampleRate: meta.sampleRate
                , bitRate: meta.bitRate
            }
        }
        , isClose
    );

    if (testOutputWavLog) {
        //测试输出一份wav，方便对比数据
        var recMock2 = Recorder({
            type: "mp3"
            , sampleRate: testSampleRate
            , bitRate: testBitRate
        });
        var chunk = Recorder.SampleData(realTimeSendTryWavTestBuffers, realTimeSendTryWavTestSampleRate, realTimeSendTryWavTestSampleRate);
        recMock2.mock(chunk.data, realTimeSendTryWavTestSampleRate);
        recMock2.stop(function (blob, duration) {
            var logMsg = "No." + (number < 100 ? ("000" + number).substr(-3) : number);
            // Runtime.LogAudio(blob, duration, recMock2, logMsg);
        });
    };
    realTimeSendTryWavTestBuffers = [];
}

//=====实时处理时清理一下内存（延迟清理），本方法先于RealTimeSendTry执行======
const RealTimeOnProcessClear = (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) => {
    if (realTimeSendTryTime == 0) {
        realTimeSendTryTime = Date.now();
        realTimeSendTryNumber = 0;
        transferUploadNumberMax = 0;
        realTimeSendTryBytesChunks = [];
        realTimeSendTryClearPrevBufferIdx = 0;
        realTimeSendTryWavTestBuffers = [];
        realTimeSendTryWavTestSampleRate = 0;
    };

    //清理PCM缓冲数据，最后完成录音时不能调用stop，因为数据已经被清掉了
    //这里进行了延迟操作（必须要的操作），只清理上次到现在的buffer
    try {
        for (var i = realTimeSendTryClearPrevBufferIdx; i < newBufferIdx; i++) {
            buffers[i] = null;
        };
        realTimeSendTryClearPrevBufferIdx = newBufferIdx;

        //备份一下方便后面生成测试wav
        for (var i = newBufferIdx; i < buffers.length; i++) {
            realTimeSendTryWavTestBuffers.push(buffers[i]);
        };
        realTimeSendTryWavTestSampleRate = bufferSampleRate;

    } catch (error) {
        console.error('Error clearing PCM buffer:', error);
    }
}

//=====数据传输函数==========
const TransferUpload = (number, blobOrNull, duration, blobRec, isClose) => {
    transferUploadNumberMax = Math.max(transferUploadNumberMax, number);
    if (blobOrNull) {
        var blob = blobOrNull;

        //*********Read As Base64***************
        var reader = new FileReader();
        reader.onloadend = function () {
            var base64 = (/.+;\s*base64\s*,\s*(.+)$/i.exec(reader.result) || [])[1];

            //可以实现
            //WebSocket send(base64) ...
            //WebRTC send(base64) ...
            //XMLHttpRequest send(base64) ...
            // console.log('base64', base64)
            // console.log('number', number)
            // console.log('duration', duration)
            // sendAudio(base64)
            //这里啥也不干
        };
        reader.readAsDataURL(blob);

        //*********Blob***************
        //可以实现
        // console.log('blob', blob)
        // 使用http请求将blob发送到服务器
        uploadAudio(blob, number)

        if (true && number % 100 == 0) {//emmm....
            // Runtime.LogClear();
        };
    };

    if (isClose) {
        // ws.close();
        console.info("No." + (number < 100 ? ("000" + number).substr(-3) : number) + ":已停止传输");
    };
}

// 将Blob转换为Base64
const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
}


let tmp_arr = []

let ws = null; // WebSocket 连接实例
let reconnectAttempts = 0; // 重连尝试次数
let reconnectTimer = null; // 重连定时器
const maxReconnectAttempts = 10; // 最大重连次数
const baseReconnectDelay = 5000; // 初始重连延迟时间（毫秒）
let currentSpeakerNumber = 1; // 添加一个变量记录当前的speaker_number

// 初始化 WebSocket 连接
const initWebSocket = (clearHistory = true) => {
    // 检查会议是否已开始且meeting_id是否有效
    if (!started.value || !meeting_id || meeting_id === 'undefined') {
        console.log('会议未开始或meeting_id无效，不建立WebSocket连接');
        return;
    }
    
    // 先关闭现有的WebSocket连接
    closeWebSocket();
    
    clearTimeout(reconnectTimer); // 清除之前的重连定时器
    
    // 只有在需要时才清空会议记录数据
    if (clearHistory) {
        res_data.value = [];
    }
    
    // 记录当前meeting_id
    previousMeetingId.value = meeting_id;
    
    // 重置说话人编号
    currentSpeakerNumber = 1;
    
    // 尝试使用域名连接，如果失败可以尝试直接使用IP地址
    try {
        // 使用正确的域名和端口
        const wsUrl = `${WS_BASE_URL}/audio/${meeting_id}`;
        console.log(`建立WebSocket连接: ${wsUrl}`);
        ws = new WebSocket(wsUrl);
        ws.binaryType = 'arraybuffer';
    } catch (e) {
        console.error('WebSocket连接失败，错误信息:', e);
    }

    ws.onopen = () => {
        console.log('WebSocket 连接成功');
        reconnectAttempts = 0; // 连接成功后重置重连计数
    };

    ws.onmessage = (event) => {
        try {
            const response = JSON.parse(event.data);
            
            // 处理说话人分割消息
            if (response.status === "speaker_segmentation") {
                console.log('收到说话人分割消息:', response);
                
                // 更新本地 speaker_number
                speaker_number = response.speaker_number;
                currentSpeakerNumber = response.speaker_number;
                
                // 删除最后一个临时段落（isspeaking=true的段落）如果存在的话
                const lastSpeakingIndex = res_data.value.findIndex(item => item.isspeaking);
                if (lastSpeakingIndex >= 0) {
                    res_data.value.splice(lastSpeakingIndex, 1);
                }
                
                // 添加服务器发送的新段落数据，不删除任何历史记录
                if (response.data && Array.isArray(response.data)) {
                    // 遍历服务器返回的所有段落并添加
                    response.data.forEach(segment => {
                        // 将毫秒时间格式化为 mm:ss 格式
                        let timeFormatted = "00:00";
                        if (segment.start !== undefined) {
                            const totalSeconds = Math.floor(segment.start / 1000);
                            const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
                            const seconds = (totalSeconds % 60).toString().padStart(2, '0');
                            timeFormatted = `${minutes}:${seconds}`;
                        }
                        
                        res_data.value.push({
                            time: timeFormatted,
                            speaker: segment.speaker || "识别中" + (segment.speaker_number || speaker_number),
                            content: segment.text || "",
                            isspeaking: false
                        });
                    });
                    
                    // 始终添加一个新的空白段落作为当前说话人的段落
                    let nextSpeakerTime = record_time.value;
                    // 如果有上一段落，获取其结束时间作为新段落开始时间
                    if (response.data.length > 0) {
                        const lastSegment = response.data[response.data.length - 1];
                        if (lastSegment.end !== undefined) {
                            const totalSeconds = Math.floor(lastSegment.end / 1000);
                            const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
                            const seconds = (totalSeconds % 60).toString().padStart(2, '0');
                            nextSpeakerTime = `${minutes}:${seconds}`;
                        }
                    }
                    
                    // 添加下一个说话人的空段落
                    res_data.value.push({
                        time: nextSpeakerTime,
                        speaker: "识别中" + (speaker_number + 1),
                        content: "",
                        isspeaking: true
                    });
                } else if (response.message) {
                    // 如果没有data数组但有message字段，直接创建新段落
                    res_data.value.push({
                        time: record_time.value,
                        speaker: "识别中",
                        content: response.message,
                        isspeaking: false
                    });
                    
                    // 添加下一个空段落
                    res_data.value.push({
                        time: record_time.value,
                        speaker: "识别中",
                        content: "",
                        isspeaking: true
                    });
                }
                
                // 滚动到底部
                scrollToBottom();
                return;
            }
            
            // 处理新增的 status: success 格式消息
            if (response.status === "success" && response.message) {
                // 获取当前时间
                const now = new Date();
                // 获取本地缓存中 的时间字符
                let timeStr = localStorage.getItem('timeStr')
                if (!timeStr) {
                    timeStr = "00:00"
                    localStorage.setItem('timeStr', timeStr);
                }
                
                // 只有当消息有内容时才添加或更新记录
                if (response.message && response.message.trim() !== '') {
                    // 查找当前正在说话的段落
                    const speakingIndex = res_data.value.findIndex(item => item.isspeaking);
                    
                    if (speakingIndex >= 0) {
                        // 如果找到了正在说话的段落，更新其内容
                        res_data.value[speakingIndex].content = response.message;
                        res_data.value[speakingIndex].time = timeStr;
                    } else {
                        // 如果没有找到正在说话的段落，创建一个新的
                        res_data.value.push({ 
                            time: timeStr, 
                            speaker: "识别中", 
                            content: response.message,
                            isspeaking: true
                        });
                    }
                    scrollToBottom();
                }
                return;
            }
            
            if (response.ok == true) {
                return;
            }

            if (response.finish) {
                // 更新本地speaker_number
                speaker_number = response.speaker_number !== undefined ? response.speaker_number : speaker_number + 1;
                currentSpeakerNumber = speaker_number;
                
                if (response.finalres && response.finalres.trim() !== '') {
                    // 查找正在说话的段落
                    const speakingIndex = res_data.value.findIndex(item => item.isspeaking);
                    
                    if (speakingIndex >= 0) {
                        // 更新找到的正在说话的段落
                        res_data.value[speakingIndex] = { 
                            time: response.time || res_data.value[speakingIndex].time, 
                            speaker: response.speaker || "识别中", 
                            content: response.finalres,
                            isspeaking: false
                        };
                    } else {
                        // 如果没有找到正在说话的段落，直接添加完成的段落
                        res_data.value.push({
                            time: response.time || record_time.value,
                            speaker: response.speaker || "识别中",
                            content: response.finalres,
                            isspeaking: false
                        });
                    }
                    
                    // 添加新的空白段落作为下一个说话人
                    res_data.value.push({ 
                        time: response.time || record_time.value, 
                        speaker: "识别中", 
                        content: "",
                        isspeaking: true
                    });
                    
                    scrollToBottom();
                }
            } else {
                // 普通消息，只更新内容，不添加新段落
                if (response.finalres && response.finalres.trim() !== '') {
                    // 查找正在说话的段落
                    const speakingIndex = res_data.value.findIndex(item => item.isspeaking);
                    
                    if (speakingIndex >= 0) {
                        // 更新找到的正在说话的段落
                        res_data.value[speakingIndex].content = response.finalres;
                    } else {
                        // 如果没有找到正在说话的段落，添加一个新的
                        res_data.value.push({ 
                            time: response.time || record_time.value, 
                            speaker: "识别中", 
                            content: response.finalres,
                            isspeaking: true
                        });
                    }
                    scrollToBottom();
                }
            }
        } catch (error) {
            console.error('处理 WebSocket 消息时出错:', error);
        }
    };

    ws.onerror = (error) => {
        console.error('WebSocket 错误:', error);
        // 发生错误时尝试重连，但仅在会议已开始且未暂停时进行
        if (started.value && !onPose.value) {
            tryReconnect();
        } else if (!started.value) {
            console.log('会议未开始，不尝试重新连接WebSocket');
        } else if (onPose.value) {
            console.log('会议已暂停，暂不尝试重新连接WebSocket，将在恢复时重连');
        }
    };

    ws.onclose = () => {
        console.log('WebSocket 连接关闭');
        // 连接关闭时尝试重连，但仅在会议已开始且未暂停时进行
        if (started.value && !onPose.value) {
            tryReconnect();
        } else if (!started.value) {
            console.log('会议未开始，不尝试重新连接WebSocket');
        } else if (onPose.value) {
            console.log('会议已暂停，暂不尝试重新连接WebSocket，将在恢复时重连');
        }
    };
};

// 尝试重新连接 WebSocket
const tryReconnect = () => {
    // 检查会议是否已开始且不在暂停状态
    if (!started.value) {
        console.log('会议未开始，不尝试重连');
        return;
    }
    
    if (onPose.value) {
        console.log('会议处于暂停状态，不尝试重连，将在恢复时重新连接');
        return;
    }
    
    if (reconnectAttempts >= maxReconnectAttempts) {
        console.log(`已达到最大重连次数 (${maxReconnectAttempts})，停止重连`);
        message.error('WebSocket连接已断开，请刷新页面重试');
        return;
    }
    
    // 使用指数退避策略计算下一次重连延迟
    const delay = baseReconnectDelay * Math.pow(1.5, reconnectAttempts);
    
    console.log(`WebSocket断开，${delay}ms后尝试第${reconnectAttempts + 1}次重连...`);
    
    reconnectTimer = setTimeout(() => {
        reconnectAttempts++;
        message.info(`正在尝试重新连接服务器... (${reconnectAttempts}/${maxReconnectAttempts})`);
        initWebSocket(false);
    }, delay);
};

// 在组件挂载时初始化 WebSocket
onMounted(() => {
    // 确保初始化时res_data为空数组
    res_data.value = [];
    
    // 仅在会议已开始时才初始化WebSocket连接
    if (started.value) {
        initWebSocket();
    } else {
        console.log('会议尚未开始，不建立WebSocket连接');
    }
    
    // 添加页面关闭事件监听
    window.addEventListener("beforeunload", handleBeforeUnload);
});

// 在组件卸载前关闭 WebSocket 连接
onBeforeUnmount(() => {
    console.log('组件卸载，关闭WebSocket连接');
    closeWebSocket();
    
    // 移除beforeunload事件监听器
    window.removeEventListener("beforeunload", handleBeforeUnload);
});

// 使用 WebSocket 发送音频数据到服务器
const uploadAudio = async (blob, number) => {
    try {
        // 检查是否处于暂停状态，如果是则不发送数据
        if (onPose.value) {
            console.log('录音已暂停，不再发送音频数据，但保持WebSocket连接');
            return;
        }

        // 检查会议是否已开始，如果未开始则不发送数据
        if (!started.value) {
            console.log('会议尚未开始，不发送音频数据');
            return;
        }

        if (!ws || ws.readyState !== WebSocket.OPEN) {
            console.error('WebSocket 未连接');
            // 如果WebSocket未连接，尝试重新连接
            if (started.value && !onPose.value) {
                tryReconnect();
            }
            return;
        }

        // 改为二进制传输：将blob转换为ArrayBuffer
        const audioArrayBuffer = await blob.arrayBuffer();
        
        // 创建二进制消息，添加简化的头部（12字节）+ 音频数据
        const headerSize = 12; // 3个4字节整数：meeting_id, number, speaker_number
        const message = new ArrayBuffer(headerSize + audioArrayBuffer.byteLength);
        const view = new DataView(message);
        
        // 填充头部信息，使用小端序(little-endian)
        view.setUint32(0, parseInt(meeting_id), true); // meeting_id
        view.setUint32(4, number, true);               // number
        view.setUint32(8, speaker_number, true);       // speaker_number
        
        // 复制音频数据
        new Uint8Array(message, headerSize).set(new Uint8Array(audioArrayBuffer));
        
        // 发送二进制数据
        ws.send(message);
        
        // 添加调试日志
        console.debug(`已发送二进制音频数据: ${audioArrayBuffer.byteLength} 字节，编号: ${number}`);
    } catch (error) {
        console.error('发送音频数据错误:', error);
        
        // 发生错误时，尝试使用旧的JSON格式作为备选
        try {
            if (ws && ws.readyState === WebSocket.OPEN) {
                const base64Audio = await blobToBase64(blob);
                const fallbackMessage = JSON.stringify({
                    audio_data: base64Audio,
                    number: number,
                    speaker_number: speaker_number,
                    meeting_id: meeting_id,
                    is_fallback: true
                });
                ws.send(fallbackMessage);
                console.warn('已切换到JSON备选方式发送');
            }
        } catch (fallbackError) {
            console.error('备选发送方式也失败:', fallbackError);
        }
    }
};

const formatMs = (ms, type) => {
    if (type == 1) {
        return (ms / 1000 / 60).toFixed(0) + ':' + (ms / 1000 % 60).toFixed(0)
    }
    return (ms / 1000 / 60).toFixed(0) + '分' + (ms / 1000 % 60).toFixed(0) + '秒'
}

//调用录音
let rec;
let wave = null;
let recBlob = null;

/**调用open打开录音请求好录音权限  Call open to open the recording and request the recording permission**/
const recOpen = () => {//一般在显示出录音按钮或相关的录音界面时进行此方法调用，后面用户点击开始录音时就能畅通无阻了
    rec = null;
    wave = null;
    recBlob = null;
    var newRec = Recorder({
        type: "mp3", sampleRate: testSampleRate, bitRate: testBitRate //mp3格式，指定采样率hz、比特率kbps，其他参数使用默认配置；注意：是数字的参数必须提供数字，不要用字符串；需要使用的type类型，需提前把格式支持文件加载进来，比如使用wav格式需要提前加载wav.js编码引擎
        , onProcess: function (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
            //录音实时回调，大约1秒调用12次本回调
            // document.querySelector(".recpowerx").style.width=powerLevel+"%";
            // document.querySelector(".recpowert").innerText=formatMs(bufferDuration,1)+" / "+powerLevel;

            //可视化图形绘制
            // wave.input(buffers[buffers.length-1],powerLevel,bufferSampleRate);
        }
    });

    newRec.open(function () {//打开麦克风授权获得相关资源
        rec = newRec;

        //此处创建这些音频可视化图形绘制浏览器支持妥妥的
        // wave=Recorder.FrequencyHistogramView({elem:".recwave"});
        recStart()
    }, function (msg, isUserNotAllow) {//用户拒绝未授权或不支持
        reclog((isUserNotAllow ? "UserNotAllow, " : "") + Html_$T("TOOV::打开录音失败：") + msg, 1);
    });
}

const Html_$T = (a) => {
    return a
}

const Html_xT = (v) => { return v }

const reclog = (s, color) => {
    message.info(s);
}

const recClose = () => {
    // 停止会议状态
    started.value = false
    onPose.value = false
    
    // 暂停计时增长
    stop_record_time()
    
    // 重置时间和计时器
    record_time.value = '00:00'
    clearInterval(record_time_interval)
    record_time_interval = null
    
    // 停止录音
    recStop()
    
    // 清空录音相关实例
    rec = null
    wave = null
    recBlob = null
    
    // 关闭WebSocket连接并重置相关变量
    closeWebSocket()
    reconnectAttempts = 0
    clearTimeout(reconnectTimer)
    reconnectTimer = null
    
    // 重置实时发送相关变量
    RealTimeSendTryReset()
    realTimeSendTryNumber = 0
    transferUploadNumberMax = 0
    realTimeSendTryBytesChunks = []
    realTimeSendTryClearPrevBufferIdx = 0
    realTimeSendTryWavTestBuffers = []
    realTimeSendTryWavTestSampleRate = 0
    
    // 重置说话人编号
    speaker_number = 1
    currentSpeakerNumber = 1
    
    // 清除会议记录数据
    res_data.value = []
    
    // 重置localStorage中可能存储的相关数据
    localStorage.removeItem('timeStr')
    
    // 修改会议状态 put meeting 请求
    axios.put(`${BASE_URL}/meetings/${meeting_id}`, { meeting_status: 2 })
        .then(response => {
            console.log('会议状态更新成功');
            // 跳转到会议编辑页面
            router.push({ path: "/meetingedit/" + meeting_id });
        })
        .catch(error => {
            console.error('更新会议状态时出错:', error);
        });
}

let userConfirmed = false;

// 修改现有的beforeunload处理函数，确保关闭WebSocket
const handleBeforeUnload = (event) => {
    console.log('页面即将关闭，关闭WebSocket连接并重置所有变量');
    
    // 如果会议已经开始但还没有结束，则先停止会议
    if (started.value) {
        // 阻止默认行为，显示确认对话框
        event.preventDefault();
        event.returnValue = '会议尚未结束，确定要离开吗？';
        
        // 执行会议结束清理操作
        started.value = false;
        onPose.value = false;
        
        // 停止计时并重置
        stop_record_time();
        clearInterval(record_time_interval);
        
        // 停止录音
        recStop();
        rec = null;
        wave = null;
        
        // 重置所有会议相关变量
        RealTimeSendTryReset();
        speaker_number = 1;
        currentSpeakerNumber = 1;
    }
    
    // 无论如何都关闭WebSocket连接
    closeWebSocket();
    
    return event.returnValue;
};

// 在组件停用时关闭WebSocket连接
onDeactivated(() => {
    console.log('组件停用，关闭WebSocket连接并重置变量');
    
    // 如果会议仍在进行中，先暂停会议
    if (started.value && !onPose.value) {
        onPose.value = true;
        stop_record_time();
        console.log('组件停用时会议被自动暂停');
    }
    
    // 关闭WebSocket连接但保留会议状态，以便再次激活时可以继续
    closeWebSocket();
    
    // 重置WebSocket连接相关变量，以便在重新激活时重新连接
    reconnectAttempts = 0;
    clearTimeout(reconnectTimer);
    reconnectTimer = null;
});

const recStart = () => {
    if (rec) {
        rec.close();
    }
    rec = Recorder({
        type: "mp3"
        , sampleRate: testSampleRate
        , bitRate: testBitRate
        , onProcess: function (buffers, powerLevel, bufferDuration, bufferSampleRate, newBufferIdx, asyncEnd) {
            // console.log('bufferDuration', bufferDuration)
            // console.log('newBufferIdx', newBufferIdx)
            // console.log('asyncEnd', asyncEnd)
            // wave.input(buffers[buffers.length-1],powerLevel,bufferSampleRate);
        }
        , takeoffEncodeChunk: function (chunkBytes) {
            //接管实时转码，推入实时处理
            RealTimeSendTry(chunkBytes, false);
        }
    });

    var t = setTimeout(function () {
        console.info("无法录音：权限请求被忽略（超时假装手动点击了确认对话框）", 1);
    }, 8000);

    rec.open(function () {//打开麦克风授权获得相关资源
        clearTimeout(t);
        rec.start();//开始录音

        // useWebSocket();
        // wave=Recorder.FrequencyHistogramView({elem:".recwave"});
        RealTimeSendTryReset();//重置
    }, function (msg, isUserNotAllow) {
        clearTimeout(t);
        console.info((isUserNotAllow ? "UserNotAllow，" : "") + "无法录音:" + msg, 1);
    });
}
const recStop = () => {
    if (rec)
        rec.close();//直接close掉即可，这个例子不需要获得最终的音频文件

    RealTimeSendTry(null, true);//最后一次发送
}

// 关闭WebSocket连接
const closeWebSocket = () => {
    if (ws) {
        // 移除所有事件监听器以防止内存泄漏
        ws.onopen = null;
        ws.onmessage = null;
        ws.onerror = null;
        ws.onclose = null;
        
        // 关闭连接
        if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
            ws.close();
            console.log('已关闭WebSocket连接');
        }
        ws = null;
    }
    
    // 清除重连定时器
    clearTimeout(reconnectTimer);
};
</script>
<style scoped lang="less">
.meeting-ongoing-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    background-color: #f5f7fa;
}

.mt-header {
    height: 80px;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 15px 25px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    align-items: center;
    background-image: url(@/assets/images/mt_bg.png);

    .mt-title {
        font-size: 16px;
        font-weight: 700;
        color: #222;
    }
}

.mt-record {
    height: calc(100% - 120px);
    display: flex;
    flex-direction: column;
    background-color: #fff;
    margin: 20px;
    box-shadow: 0px 0px 13px 0px rgba(61, 122, 227, 0.2);
    border-radius: 6px;
    padding: 20px;

    .mt-record-header {
        padding: 10px 0;
    }

    .mt-record-content {
        flex: 1;
        overflow-y: auto;

        .record-item {
            margin-bottom: 15px;
            
            &:first-child {
                margin-top: 0;
            }
            
            &:last-child {
                margin-bottom: 0;
            }
        }

        .content {
            background: #F8FAFC;
            box-shadow: 0px 0px 6px 0px rgba(61, 122, 227, 0.2);
            border-radius: 6px;
            border: 1px solid #D3DEF4;
            padding: 10px 15px;
        }

        .speaker {
            font-size: 12px;
            color: #888;
            padding: 0 16px;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                left: 2px;
                top: 50%;
                margin-top: -4px;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: #1F5BC3;
                box-shadow: 0px 1px 3px 0px rgba(0, 94, 255, 0.4);
            }
        }

        .time {
            font-size: 12px;
            color: #999;
            margin-right: 10px;
        }

        .icon-micro {
            width: 10px;
        }
    }

    .mt-record-state {
        display: flex;
        align-items: center;
        padding: 10px 10px 0;
        border-top: 1px solid #E8EFF3;

        .recording {
            width: 32px;
            margin-right: 24px;
        }

        .state {
            flex: 1;
            color: #222;

            .record-time {
                font-size: 12px;
            }

        }

        .action {
            display: flex;

            img {
                width: 40px;
                cursor: pointer;
            }
        }
    }
}
</style>
